import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import EmployeesContainer from '../../../containers/organizations/EmployeesContainer.jsx';

const Employees = ({ slug }) => (
  <>
    <Helmet>
      <title>Organization Employees | ChangeSync</title>
    </Helmet>

    <EmployeesContainer slug={slug} />
  </>
);

Employees.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(Employees));
